import { PLAYER_PROFILE, PLAYER_WALLET } from '~/utils/api-response/player'
import { SHARE_LINK } from '~/utils/api-response/settings'

// State
export const state = () => ({
  // loginPopup: false,
  token: null,
  loading: false,
  totalBalanceLoading: false,
  player: {
    balance: 0
  },
  totalBalance: '',
  totalBalanceFromSocket: null,
  profile: null,
  messages: [],
  deposits: [],
  withdrawals: [],
  wallets: {},
  providerWallets: [],
  affiliates: [],
  onHoldWallet: 0,
  activityWallet: 0,
  playerInviteAndEarnDomain: { domain: null },
  cancelToken: {}
})

// Actions
export const actions = {
  // Profile
  profile({ commit, dispatch }) {
    const clonePlayerProfile = JSON.parse(JSON.stringify(PLAYER_PROFILE))
    if (this.$cookie.get('username')) {
      clonePlayerProfile.data.player_id = this.$cookie.get('username')
    }
    if (this.$cookie.get('nickname')) {
      clonePlayerProfile.data.nickname = this.$cookie.get('nickname')
    }
    const response = clonePlayerProfile
    commit('setPlayer', response.data)
    commit('setTotalBalance', response?.data?.balance)
    dispatch('player/totalBalanceSocket', true, { root: true })
    this.$cookie.set('player', response.data)
  },

  // Update
  async update({ commit }, form) {},
  // ? GET TOTAL BALANCE
  totalBalance({ commit, state }) {
    const response = PLAYER_WALLET
    commit('setTotalBalance', response?.data?.main_wallet)
    commit('setOnHoldWallet', response?.data?.on_hold_wallet)
    commit('setActivityWallet', response?.data?.activity_wallet)
  },
  affiliates({ commit }) {
    commit('loading', true)
  },
  totalBalanceSocket({ commit }, params) {
    commit('setTotalBalanceSocket', params)
  },
  async playerWalletsTransfer({ commit }, form) {},
  setHoldBalance({ commit }, val) {
    commit('setOnHoldWallet', val)
  },
  getPlayerInviteAndEarnDomain({ commit }, params) {
    const response = SHARE_LINK
    commit('setPlayerInviteAndEarnDomain', response.data)
    this.$cookie.set('referral_domain', response.data?.domain, {
      path: '/',
      maxAge: 60 * 60 * 3 - 60
    })
  }
}

// Mutations
export const mutations = {
  setPlayer: (state, data) => {
    state.player = data
  },
  loading: (state, type) => {
    state.loading = type
  },
  totalBalanceLoading: (state, type) => {
    state.totalBalanceLoading = type
  },
  setMessages(state, data) {
    state.messages = data
  },
  wallets: (state, v) => {
    state.wallets = v
  },
  setTotalBalance: (state, v) => {
    state.totalBalance = v
    state.totalBalanceFromSocket = v
  },
  setTotalBalanceSocket: (state, data) => {
    state.totalBalanceFromSocket = data.total_balance
  },
  affiliates: (state, data) => {
    state.affiliates = data
  },
  setOnHoldWallet: (state, data) => {
    state.onHoldWallet = data
  },
  setActivityWallet: (state, data) => {
    state.activityWallet = data
  },
  setPlayerInviteAndEarnDomain: (state, data) => {
    state.playerInviteAndEarnDomain = data
  },
  setPlayerBalance: (state, balance) => {
    const playerBalance = JSON.parse(JSON.stringify(state.player))
    playerBalance.balance = balance
    state.player = playerBalance
  },
  setCancelToken: (state, data) => {
    const oldData = {
      ...state.cancelToken
    }
    state.cancelToken = {
      ...oldData,
      ...data
    }
  }
}
